// Note: \u202F is unicode for non-breaking-space!
export function formatWithCurrency(amount: number, currencyCode: CurrencyCode, locale = 'nb-NO') {
    const symbol = getCurrencySymbol(currencyCode);
    const amountStr = Math.round(amount).toLocaleString(locale);
    return symbol == '€' ? `${symbol}\u202F${amountStr}` : `${amountStr}\u202F${symbol}`;
}

export function formatWithCurrencyNoDecimals(amount: number | null | undefined, country: Country) {
    const code = getCurrencyCode(country);
    if (amount === null || amount === undefined) {
        return `-\u202F${getCurrencySymbol(code)}`;
    }
    const locale = getLocale(country);
    return formatWithCurrency(amount, code, locale);
}

export function formatWithCurrencyTwoDecimals(amount: number | null | undefined, country: Country) {
    const currencyCode = getCurrencyCode(country);
    const symbol = getCurrencySymbol(currencyCode);
 
    if (amount === null || amount === undefined) {
        return `-\u202F${symbol}`;
    }

    const amountStr = formatWithTwoDecimalsNoCurrencySymbol(amount, country);
    return symbol == '€' ? `${symbol}\u202F${amountStr}` : `${amountStr}\u202F${symbol}`;
}

export function formatWithTwoDecimalsNoCurrencySymbol(amount: number, country: Country,) {
    const locale = getLocale(country);
    return amount.toLocaleString(locale,  {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
}

export function formatWithWihNoDecimals(amount: number, country: Country) {
    const locale = getLocale(country);
    return Math.round(amount).toLocaleString(locale);   
}

export function getCurrencySymbol(currencyCode: CurrencyCode): string {
    switch (currencyCode) {
        case 'EUR':
            return '€';
        case 'NOK':
            return 'kr';
        case 'SEK':
            return 'kr';
    }
}

export const getCurrencyCode = (symbol: Country): CurrencyCode => {
    switch (symbol) {
        case 'FI':
            return 'EUR';
        case 'NO':
            return 'NOK';
        case 'SE':
            return 'SEK';
    }
};

export const getLocale = (country: Country) => {
    switch (country) {
        case 'FI':
            return 'fi-FI';
        case 'NO':
            return 'nb-NO';
        case 'SE':
            return 'sv-SE';
    }
};

export type CurrencyCode = 'EUR' | 'NOK' | 'SEK';
